export default __webpack_public_path__ + "static/media/ue-product-of-week.00c8e359.svg";